/**
 * Comment-related strings.
 */
import React from 'react';

export default {
	d_basicInfo: 'Basic Info',
	h_basicInfo: <div>
		<p>Basic information, like the campaign name and the category of campaign it is (e.g. Website or Social).</p>
	</div>,

	d_costs: 'Costs',
	h_costs: <div>
		<p>All costs associated with this campaign.</p>
		<ul>
			<li><b>Hard Costs</b> How much money have you spent on this campaign, outside of recurring costs?
				For example, if you paid $300 for work on your website, and $10/month to host it, the $300 is
				considered a hard cost, and the $10/month is the recurring cost.
			</li>
			<li><b>Recurring Costs</b> This is the amount you pay every month/quarter/year for the campaign.</li>
			<li><b>Labor Costs</b> Time is money! This is the amount of your (or your staff's) time, times their
				billing rate.
			</li>
		</ul>
	</div>,

	d_kpis: 'KPIs',
	h_kpis: <div>
		<p>KPI stands for Key Performance Indicators.</p>
		<p>These are the metrics by which you determine the success or failure of your campaigns.</p>
		<ul>
			<li><b>Leads</b> The number of leads that this campaign has created.</li>
			<li><b>$/Lead</b> How much does each lead cost you, on average, for this campaign?</li>
			<li><b>Conv%</b> What is the conversion rate for this campaign?
				For example, a conversion rate of 50% indicates that 50% of leads from this campaign convert into a
				client.
			</li>
		</ul>
	</div>,

	d_roi: 'Return on Investment',
	h_roi: <div>
		<p>These are the metrics by which you determine the success or failure of your campaigns.</p>
		<ul>
			<li><b>Billed ROI</b> What is the return on investment (ROI) for this campaign? Good marketing campaigns
				should bring you 5x your investment, so if you invest $1000 in a campaign, you would expect a return of
				$5000 in business.
				The billed ROI tells you what the ROI is based on your billed amounts.
			</li>
			<li><b>Collected ROI</b> tells you the ROI for your campaign based on paid invoices. The is the more
				important
				of the two numbers, as it tells you the TRUE value of this campaign. A campaign that brings you lots of
				clients
				that do not pay their bills is a terrible campaign!
			</li>
		</ul>
	</div>
};
